import { gql, useLazyQuery, useQuery } from "@apollo/client";
import React, { useState } from "react";
import "./Dashboard.scss";
import { Loading, LoadTable } from "../../Components";
import RefreshIcon from "./RefreshIcon";
import IsoToDateTime from "../../../CommonFunction/IsoDateTime";
import useFetchTableData from "../../custom_hooks/useFetchTableData";

const queryfunction = (fields) => {
  const query = gql`
   query GetAllStatusOfAccountQuery {
    getAllStatusOfAccountQuery {
      _id
      status
      Profile_Type
      Business_Mobile_Number
      Business_Name
      KYC_Complete
      Is_VehicleTypeAdded
      Is_LaneAdded
      planSubscription{
    subscriptionType
    }
    TrackingBalance{
    Tracking_Balance
    }
    Current_Location_Address
    Unique_Id
    createdAt
     ${fields?.join(" ")}
    }
  }
  `;
  return query;
};

const AccountActivityStatus = () => {
  const Key = "AccountActivity";
  const [isLoading, setIsLoading] = useState(true);
  function formatShipmentData(data) {
    // console.log(data);//Current_Location
    return data?.map((entry) => {
      return {
        _id: entry._id,
        status: entry.status,
        Profile_Type: entry.Profile_Type,
        Business_Mobile_Number: entry.Business_Mobile_Number,
        Business_Name: entry.Business_Name,
        KYC_Complete: entry.KYC_Complete,
        Is_LaneAdded: entry.Is_LaneAdded,
        Is_Vehicle_Type_Added: entry.Is_VehicleTypeAdded,
        subscriptionType: entry?.planSubscription?.[0]?.subscriptionType,
        TrackingBalance: entry?.TrackingBalance?.Tracking_Balance,
        Current_Address: entry.formattedAddress,
        Unique_Id: entry.Unique_Id,
        createdAt: IsoToDateTime(entry.createdAt),
      };
    });
  }
  const [FetchAccountActivity, { data, loading, error, refetch, networkStatus }] = useLazyQuery(
    gql`
      query GetAllStatusOfAccountQuery {
        getAllStatusOfAccountQuery {
          _id
        }
      }
    `,
    {
      context: { headers: { "X-GraphQL-Server": "secondary" } },
      notifyOnNetworkStatusChange: true,
    },
    {
      onCompleted: () => {
        setIsLoading(false);
      },
      onError: () => {
        setIsLoading(false);
      },
    }
  );
  const updateData = data?.getAllStatusOfAccountQuery && formatShipmentData(data?.getAllStatusOfAccountQuery);
  console.log(updateData);
  // if (loading) {
  //   // <Loading />;
  //   return <div></div>;
  // }

  useFetchTableData(queryfunction, FetchAccountActivity, setIsLoading, Key);
  if (error) {
    return <p>Error: {error.message}</p>;
  }
  return (
    <>
      <div className="title_With_Loading_Logo">
        <div className="load-post-title">Account Activity Status</div>
        <div className="load-post-logo">
          <RefreshIcon handleRefetch={refetch} loading={loading} />
        </div>
      </div>
      <div className="Account_Track_Shipments_Box">
        {isLoading && (!updateData || updateData?.length === 0) && <Loading />}
        {updateData?.length && (
          <LoadTable data={updateData} loading={loading} error={error} title={Key} settings={false} options={false} />
        )}
      </div>
    </>
  );
};

export default AccountActivityStatus;
